import '@babel/polyfill';
import 'jquery-ui/themes/base/all.css';
import ko from 'knockout';
import 'bootstrap';
window.ko = ko;

//Layout ViewModels
import HeaderViewModel from './layout/HeaderViewModel';
import CarouselViewModel from './layout/CarouselViewModel';
import ModalController from './layout/ModalController';
import NavController from './layout/NavController';

const headerViewModel = new HeaderViewModel;
let headerVM = document.getElementById('headerVM');
if (headerVM) ko.applyBindings(headerViewModel, headerVM);

let footerVM = document.getElementById('footerVM');
if (footerVM) ko.applyBindings(headerViewModel, footerVM);

let carouselVM = document.getElementById('carouselVM');
if (carouselVM) ko.applyBindings(new CarouselViewModel, carouselVM);

//Reservation ViewModels
import SizeGuideViewModel from './reservations/SizeGuideViewModel';
import ReservationViewModel from './reservations/ReservationViewModel';
import InsuranceViewModel from './reservations/InsuranceViewModel';
import CheckOutViewModel from './reservations/CheckOutViewModel';
import ConfirmationViewModel from './reservations/ConfirmationViewModel';
import RentalAgreementViewModel from './reservations/RentalAgreementViewModel';
import RentalOrderViewModel from './reservations/RentalOrderViewModel';

let sizeGuideVM = document.getElementById('sizeGuideVM');
if (sizeGuideVM) ko.applyBindings(new SizeGuideViewModel, sizeGuideVM);

let reservationVM = document.getElementById('reservationVM');
if (reservationVM) ko.applyBindings(new ReservationViewModel, reservationVM);

let insuranceVM = document.getElementById('insuranceVM');
if (insuranceVM) ko.applyBindings(new InsuranceViewModel, insuranceVM);

let checkOutVM = document.getElementById('checkOutVM');
if (checkOutVM) ko.applyBindings(new CheckOutViewModel, checkOutVM);

let confirmationVM = document.getElementById('confirmationVM');
if (confirmationVM) ko.applyBindings(new ConfirmationViewModel, confirmationVM);

let rentalAgreementVM = document.getElementById('rentalAgreementVM');
if (rentalAgreementVM) ko.applyBindings(new RentalAgreementViewModel, rentalAgreementVM);

let rentalOrderVM = document.getElementById('rentalOrderVM');
if (rentalOrderVM) ko.applyBindings(new RentalOrderViewModel, rentalOrderVM);

//Customer ViewModels
import CustomerContractsViewModel from './customer/CustomerContractsViewModel';
import ContractPaymentViewModel from './payment/ContractPaymentViewModel';

let customerContractsVM = document.getElementById('customerContractsVM');
if (customerContractsVM) ko.applyBindings(new CustomerContractsViewModel, customerContractsVM);

let contractPaymentVM = document.getElementById('contractPaymentVM');
if (contractPaymentVM) ko.applyBindings(new ContractPaymentViewModel, contractPaymentVM);

//Review ViewModel
import ReviewViewModel from './review/ReviewViewModel';

let reviewVM = document.getElementById('reviewVM');
if (reviewVM) ko.applyBindings(new ReviewViewModel, reviewVM);

//Overlay ViewModel
import OverlayImageViewModel from './overlayImage/OverlayImageViewModel';

let overlayImageVM = document.getElementById('overlayImageVM');
if (overlayImageVM) ko.applyBindings(new OverlayImageViewModel, overlayImageVM);

//EmbeddedMap ViewModel
import EmbeddedMapViewModel from './embeddedMap/EmbeddedMapViewModel';

let embeddedMapVM = document.getElementById('embeddedMapVM');
if (embeddedMapVM) ko.applyBindings(new EmbeddedMapViewModel, embeddedMapVM);

//ContactUs ViewModel
import ContactUsViewModel from './contactUs/ContactUsViewModel';

let contactUsVM = document.getElementById("contactUs");
if (contactUsVM) ko.applyBindings(new ContactUsViewModel, contactUsVM);

let contactUsPopUpVM = document.getElementById("contactUsPopUp");
if (contactUsPopUpVM) ko.applyBindings(new ContactUsViewModel, contactUsPopUpVM);

ModalController.Load();
NavController.Load();